import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #1E1E1E;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 4px;
`;

const IconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 0;
  background: transparent;
  color: #A0A0A0;
  &:hover { background: rgba(255,255,255,0.06); color: #EAEAEA; }
`;

const Label = styled.div`
  color: #EAEAEA;
  font-size: 14px;
  font-weight: 600;
  padding: 4px 8px;
`;

type Props = {
  date: Date;
  onPrev: () => void;
  onNext: () => void;
};

const MonthStepper: React.FC<Props> = ({ date, onPrev, onNext }) => {
  const month = date.toLocaleString('pt-BR', { month: 'long' });
  const year = date.getFullYear();

  const monthCap = month.charAt(0).toUpperCase() + month.slice(1);

  return (
    <Wrapper>
      <IconBtn aria-label="Mês anterior" onClick={onPrev}>
        <FiChevronLeft size={18} />
      </IconBtn>
      <Label>
        {monthCap} {year}
      </Label>
      <IconBtn aria-label="Próximo mês" onClick={onNext}>
        <FiChevronRight size={18} />
      </IconBtn>
    </Wrapper>
  );
};

export default MonthStepper;

